import { render, staticRenderFns } from "./DeleteCouponRule.vue?vue&type=template&id=c2ec2c42&scoped=true"
import script from "./DeleteCouponRule.vue?vue&type=script&lang=js"
export * from "./DeleteCouponRule.vue?vue&type=script&lang=js"
import style0 from "./DeleteCouponRule.vue?vue&type=style&index=0&id=c2ec2c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ec2c42",
  null
  
)

export default component.exports